<template>
  <div class="dlrVROncall">
    <div class="dlrVROncall-bg">
      <div class="dlrVROncall-left">
        <div class="dlrVROncall-portrait">
          <img v-if="isAvatar" :src="saler.avatar" />
          <img
            v-else
            src="https://s.autoimg.cn/dealer/m/im/images/imB-head.png"
          />
        </div>
        <div class="dlrVROncall-info">
          <div class="dlrVROncall-name" v-if="saler">
            <p>{{saler.userName}}</p>
          </div>
          <div class="dlrVROncall-time">
            <p>{{ initValue }}</p>
          </div>
        </div>
      </div>
      <div class="dlrVROncall-right">
        <div class="dlrVROncall-voice">
          <a
            v-if="speakerShow"
            href="javascript:void(0);"
            :class="{ stop: !isOPen, disabled: isDisabled }"
            v-stat:show="{ action: pvTrackApeakerShow }"
            v-stat:click="{
              action: pvTrackApeakerClick,
              extend: { isOPen: isOPen },
            }"
            @click="switchSpeaker"
          >
            <em class="icon-voice"></em>
          </a>
        </div>
        <div class="dlrVROncall-btn">
          <a 
            href="javascript:void(0);"
            v-stat:click="{ action: hangupActionName, extend }"
            @click="isOffCall"
          >
            <span>离开</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import SalerEndService from '@/services/vrShow/saler.end.service.js';
import { ActionSync } from '@/services/actionSync/hall.action.sync';
import * as layerNames from '@/services/layerName';
import layerManager from '@/services/layer.manager';
import { USER_TYPE } from '../../services/socketIO/const';
import appSettingService from '../../services/vrShow/appSetting.service';
import { speakerState } from '@/services/vrShow/state.listen.service';
import runTimer from '../../mixins/runTimer';
import config from '@/config/index';
import { isHeigherIcsSetWebViewAppVersionNum } from '@/services/vrShow/vr.show.loader';
  const hangupActionName = 'ZNZT-vrdk-app_subject_002';
  const pvTrackClick = 'ZNZT-vrdk-icsapp_hangUp_click';
  const pvTrackCancelClick = 'ZNZT-vrdk-icsapp_hangUp_cancel_click';
  const pvTrackShow = 'ZNZT-vrdk-icsapp_hangUp_show';
  const pvTrackApeakerClick = 'ZNZT-vrdk-app_speaker_saler_click';
  const pvTrackApeakerShow = 'ZNZT-vrdk-app_speaker_saler_show';
export default {
  inject: ['panoPromise'],
  mixins: [runTimer],
  data () {
    return {
      saler: null,
      channelId: '',
      channelName: '',
      isOPen: false,
      isDisabled: true,
      isShowSpeakerButtonState: false,
      hangupActionName,
      pvTrackClick,
      pvTrackCancelClick,
      pvTrackShow,
      pvTrackApeakerClick,
      pvTrackApeakerShow,
    };
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      vrSalesInfo: 'sales/vrSalesInfo',
      callStatus: 'callStatus/callStatus',
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
    speakerShow () {
      if (this.callStatus === 2 && this.isShowSpeakerButtonState) {
        return true;
      }
      return false;
    },
    extend () {
      return { channelId: this.vrSalesInfo.channelId || this.channelId };
    },
    isAvatar () {
      return this.saler && this.saler.avatar && this.saler.userId;
    },
  },
  created () {
    this.onStartHome();
    this.onEndHome();
    this.initSalerService();
    // 监听Botton组件用户发起语音通话
    this.onAdviser();
    // 监听呼叫中的取消事件
    this.OnVrCallOff();
    // 监听用户端选择看车意向动作完成
    this.onSendPicListPromise();
    // 监听扬声器
    this.onIsOpenSpeaker();
  },
  methods: {
    ...mapMutations({
      setTelCallState: 'callStatus/setTelCallState',
      setVrSalesInfo: 'sales/setVrSalesInfo',
      setUserInfo: 'sales/setUserInfo'
    }),
    ...mapActions({
      phoneCall: 'phoneCall/onCall',
      phoneOffCall: 'phoneCall/offCall',
    }),
    onIsOpenSpeaker () {
      this.$bus.$on('isOpenSpeaker', ({ souneState }) => {
        this.isOpenSpeaker(souneState);
      });
    },
    onSendPicListPromise () {
      this.$bus.$on('sendPicListPromise', () => {
        // 触发顾问端用户看车意向查询
        this.$bus.$emit('optPicListPromise', {
          channelId: this.channelId,
          channelName: this.channelName,
        });
      });
    },
    onStartHome () {
      this.$bus.$on('startHome', () => {
        this.phoneCall();
        appSettingService.onPhoneCallOnOrOff(true);
        this.panoPromise.then((panoInstance) => {
          panoInstance.loadedPromise.then(() => {
            panoInstance.canAutorotate = false;
            panoInstance.autorotate(false);
          });
        });
      });
    },
    onEndHome () {
      this.$bus.$on('endHome', () => {
        this.$bus.$emit('offCalled');
        this.setTelCallState(0);
        this.phoneOffCall();
        appSettingService.onPhoneCallOnOrOff(false);
        this.panoPromise.then((panoInstance) => {
          panoInstance.loadedPromise.then(() => {
            panoInstance.canAutorotate = true;
            panoInstance.autorotate(true);
          });
        });
        this.actionSync && this.actionSync.stop();
      });
    },
    OnVrCallOff () {
      this.$bus.$on('vrCallOff', () => {
        this.offCall();
      });
    },
    onAdviser () {
      this.$bus.$on('adviser', ({ userInfo, salesInfo, channelName, channelId }) => {
        this.startActionSync();
        this.channelId = channelId;
        this.channelName = channelName;
        if (userInfo.userId) {
          this.setTelCallState(2);
          this.setUserInfo({
            userName: userInfo.userName,
            userId: userInfo.userId
          });
          this.saler = userInfo;
        }
        this.setVrSalesInfo({ 
          channelId,
          salesId: salesInfo.userId
         });
        this.$bus.$emit('called');
        layerManager.openToast({ message: '屏幕同步连接中', iconCls: 'iconLoading', hasMask: false });
        const roomId = `u-${userInfo.userId}_s-${salesInfo.userId}`;
        this.actionSync.joinRoom(roomId);
        const v = this.salerEndService.encrysalesInfo?.appversion;
        if (isHeigherIcsSetWebViewAppVersionNum(v)) {
          this.setNewWebView();
        }
      });
    },
    setNewWebView () {
      const dealermUrl = window.origin;
      const url = `${dealermUrl}/vr/icsapp/entrance?busi=vrShareTask&dealerids=${this.dealerId}`;
      this.salerEndService.icsSetNewWebView({
        title: 'VR带看-任务中心',
        url,
        showNaviBar: 1
      });
    },
    initSalerService () {
      const isDebug = this.$queryParams.userType === USER_TYPE.SALES;
      if (isDebug) {
        import('../../services/vrShow/mock/end.service.mock').then(({ SalerEndMockService }) => {
          this.salerEndService = new SalerEndMockService({
            userId: this.$queryParams.userId
          }, {
            userId: this.$queryParams.salesId
          });
          this.salerEndService.receive();
        });
      } else {
        this.salerEndService = new SalerEndService();
        this.salerEndService.receive().then((res) => {
          this.channelId = res.channelId;
          this.channelName = res.channelName;
          this.isShowSpeakerButtonState = this.salerEndService.isShowSpeakerButtonState;
        });
      }
    },
    startActionSync () {
      const self = this;
      const actionSync = new ActionSync('', USER_TYPE.SALES);
      self.actionSync = actionSync;
      this.panoPromise.then(function (panoInstance) {
        actionSync.on('connected', function () {
          panoInstance.canAutorotate = false;
          panoInstance.autorotate(false);
          panoInstance.loadedPromise.then(function () {
            layerManager.closeToast();
          });
        });
      });
    },
    isOffCall () {
      layerManager.open(layerNames.OFFCALLMODAL, {
        title: '结束VR带看',
        content: '您将结束本次带看服务，是否确定结束？',
        showCancel: true,
        cancelText: '再等等',
        okText: '确定结束',
        pvTrackClick: this.pvTrackClick,
        okExtend: this.extend,
        pvTrackShow: this.pvTrackShow,
        pvTrackCancelClick: this.pvTrackCancelClick,
        cancelExtend: this.extend,
        onOk: () => {
          this.offCall();
        },
      });
    },
    offCall () {
      this.saler = null;
      this.setTelCallState(0);
      this.salerEndService.hangUpIcs({
        node:{ nodeName: 'button', desc: '顾问手动挂断',dealerId: this.dealerId }
      });
    },
    isOpenSpeaker (channelState) {
      if (channelState === speakerState.routeEarPiece) {
        this.isOPen = false;
        this.isDisabled = false;
      }
      if (this.isClosedWithSpeaker(channelState)) {
        this.isOPen = true;
        this.isDisabled = false;
      }
      if (this.isDisabledWithSpeaker(channelState)) {
        this.isOPen = false;
        this.isDisabled = true;
      }
    },
    // 扬声器控制器
    switchSpeaker () {
      if (this.isDisabled) {
        return;
      }
     this.salerEndService.switchSpeaker(this.isOPen).catch((err) => {
        console.log('salerEndService switchSpeaker is err:  ' + JSON.stringify(err));
      });
    },
    // 关闭按钮，不禁用
    isClosedWithSpeaker (channelState) {
      return [
        speakerState.routeSpeakerPhone,
        speakerState.routeHeadsetNoMic,
      ].includes(channelState);
    },
    // 关闭外放按钮，并禁用
    isDisabledWithSpeaker (channelState) {
      return [
        speakerState.routeHeadset, // 有线耳机（带麦克风）
        speakerState.routeHeadsetBluetooth,// 暂时没有监听到
        speakerState.routebluetoothVoice, // 我的蓝牙耳机
      ].includes(channelState);
    },
  }
};
</script>
<style lang="scss" scoped>
.dlrVROncall {
  position: absolute;
  left: ptrd(20px);
  width: ptrd(500px);
  top: ptrd(180px);
  z-index: 3;
  &-bg {
    background: rgba(0, 0, 0, 0.7);
    border-radius: ptrd(10px);
    display: flex;
    align-items: center;
    height: ptrd(88px);
    padding: 0 ptrd(20px);
  }
  &-left {
    flex: 1;
    width: 1%;
    display: flex;
    align-items: center;
  }
  &-portrait {
    flex-shrink: 0;
    width: ptrd(64px);
    height: ptrd(64px);
    border-radius: ptrd(64px);
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-info {
    flex: 1;
    width: 1%;
    margin-left: ptrd(16px);
    margin-right: ptrd(8px);
  }
  &-name {
    font-size: ptrd(28px);
    color: #ffffff;
    font-weight: bold;
    line-height: ptrd(32px);
    @extend %ellipsis-basic;
  }
  &-time {
    font-size: ptrd(26px);
    color: rgba(255, 255, 255, 0.7);
    line-height: ptrd(30px);
    @extend %font-number;
    margin-top: ptrd(4px);
  }
  &-right {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
  &-voice {
    flex-shrink: 0;
    margin-right: ptrd(28px);
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: ptrd(56px);
      height: ptrd(56px);
      background: linear-gradient(180deg, #ffffff 2%, #e6ebf5 100%);
      border-radius: ptrd(8px);
      .icon-voice {
        width: ptrd(28);
        height: ptrd(28);
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAFdUlEQVRIS82Wf0xTVxTH77uvpcX28V7BbVgIbcGa6fhhBAfGEBlkYMTELLIM4pQscySObGbaBOeMXRfNNhLjYsimjPljs2QhLroES4iRCmYZjUOJwtwqg5XY4tKUbrS1L9r77nJf+rr6Vn7sH7P+03fPved87vfce857FMaYBk/xR/2vgRaLRReNRstisdhzSqXS19HRMZCcnGvXrlFVVVV4oYQtSWFbW9syv9//GgCgEmNMSQEZhtl/4sSJWWm8e/fu/QAAg0KhOHPy5MlbqcCLAvfs2ZM9Nzd3gKKoLHkAjUZz4NSpU17J3tzc/DHGWE/GCoXi0unTpy/KfRYEElggEDgCANBi/O9MsSxr6erqui8FbW1tfSYQCFgAAHnERtN0r91utydD5wWSNLrd7k8xxjmY5JGixFRKz+Rfq9XutdvtCSCZt9lsqjt37rwrCMKLZJyenv6J3W4fkaAJYFNTk57n+UKMsYLEFwRhA0KoRJ6SOFvkMgzzdk9Pz3RnZyfs7+8vValUE93d3UGbzaYcGRk5JgiCAUIY1ul0refOnfuTxBKBW7duLX/06JE1VYkkK5LDMzMzWwiwvr7+5Vgstg9CGGAY5r2enh7/9u3bc8PhcAfGWEXTdHdfX983CWB1dfXxVGrkKRQdKIpsUkwxwzBv9Pb2erZs2WJ8+PDhFwAAJYRwfGBgYC9ZW1NT8w5CaBvZSGNjY1NLS4sgKty4ceN5QRCMS2k4STzMcdxOh8Pxezx4Lc/zh8ie1Gq15erVq67a2tr8SCRyltjS0tIOOp3O6yKwvLz8W4SQKWXd/CNIvKayM2x0Op1Tkl9FRcUZhNBqmqZHhoeHW4mdxCZiIIRfuVyuL0VgcXHxBYqiCuKOJDC5kSk7BikPcmHJv06naxgcHJyUgKWlpQ0IofcBAKHR0dEqYl+3bt1ngiBUQgj7bt68eUgErlmz5nsAQL5cQfzMEvdGPp+RkbHN5XL9JgHLysrKotHoGbIZo9G4yeFwzBYVFbUJgvA6RVGjY2NjO0Wg2Wy+jDFeucQzFNURlRzH1d+4cWNC8ispKVkfiUTOk7Fer98wNDQ0azabP8AY74IQ3nK73Y0i0GAw9GOMV82TUim9Ug9NpJzjuLrbt2/fk4D5+fk7YrHYEYqi/vJ4PGuJ3WQydSGEamiavjg1NbVPBOr1+gEJKK+75DKQZ4BhmGq32+2W7Hq9/rIgCCUQwh98Ph9p9mDFihVOjLGZpunjXq/3mAhcvnz5dQkoXYh4J0ukT+qlyRvQaDSVHo/nVxI4Jyengef5z8mzWq1u9Hq9A3l5eavD4fAgiaVUKpsfPHjQJwJZlr0EANi0WKHLFXIcV0GABoPh+WAwOAQASMMYD4dCoc1kLcuyxzDGb2KMZywWS6HVakUiUKfTVfI8/x3GeJlc4UIXieO4spmZmV+0Wu2Ox48fd1IU5c3MzKz2+Xz3c3JyVgYCgWEAwDKapo9GIpGjidZGHoxG47N+v389xjiNjGOx2KsIoYZ4PaasS5Zl187Ozt612Wx0e3v75qysrJ+mp6f/qKurU1+5cuVHAEAhACCYm5tbROxPAOVKCgsL08fHx8kOX5hPpVarLQqFQneT5+N+XwMAXiGbValU23ied0hrFnwBMwyzKhwOk++W7FRQOTAjI6MgFApdAAAUkfUQwnaE0MFk30U/MViWzZ+bm+snJSWHJgMLCgq0k5OTP5OaJ8oghEcOHz78kdVqfaJFLgokkOzs7Cy/3/+hIAhvkc8VCcxxnDEYDIpvfLPZrJmYmCBdJ02lUu3ief5yqqwsCSg5ErWRSOQljHExAOAeQqgjOajJZGI0Gk1sbGwsOt+5/yfgQiWy1LmnDvwbMwf+OxNTjXIAAAAASUVORK5CYII=);
      }
      &.stop {
        background: rgba(0, 0, 0, 0.3);
        .icon-voice {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAADqklEQVRIS7WWS6iWVRSGnzcrowvdKCHRQiNLu9DAQR7TyG5SmRY40EyKgopCHEhRJJhBFxyIFdUgiooamllxyjBCzIoyCVIw6GaIKdmggiJpxfux9mGfr+//z2lw9uScf39rr2ettddli1wRcb3/lfRO2RuLv7LShL2dgA2SVowFrHGoA+itByU92YZGxCRgMTAN2C1pfS0TEUfZfknRy+ACtOAbqayxAbhN0mtp0CnAOuB2wLJlTZH0XXUtW4FLLSfpzS5oA0yl44FB4Irc+hvwvf4AvAec06FghqTdlQ7/f0EavAZ4tO3tEDChJwPbgItSye+Awaf2CFEbaKM2ARen/DpJq+qzw4AJPQvYAUweReIMA+b5E4BXgUXp6Y115tchVXE/IhyWLwGHud9qgBFxNHAd8LmkAxFxHPBpevoLcKH3ragkzTXAA74zSX+mpXcBLxSZfiGNiOXAy8BPwCxJ+yLCmbwTOB5YK2l1DXSyXAs4s26R9E9C1wIP94EWD2cAX2REtkuaneefBe4F9gNnSzpSPPwamJ5ePC/pnirzXgGWjZQ0EbEUaMoImC9pMCKcfF/l3kJJm7qA/v6IpMcq6IdVudTsdpZ+BswEtkqal16WUmnC2gto2TskvVRB9wDntzxtA+8GngMOSzo9gS6TBfZe0rJ+wCPATZLezYPHAj8CEyro/ZKeqYyaA3yUvydIOhgRbn/uzc3d9gP63B/AlZIcKjf504DvgZNS6V/APEnb83s/4MeSBkYCWs8hYEDSN6n0XMBJZo+9DgOzJe2JiBLSXyXZOBtZQvq6pKWjAfrct1lfP6eSgQzduIQ61JdlWfVKmsclPTRaoPW6iOdKcn+15R5TLwInJnQf4PHl1VUWCyRtLsAPfBetDOz6+T5wgyQ3dEOvBvxCOKYS3iFpVn5/GrgPcFubVBf+3DzoxjvScnF7VjZDNiJuBdwcSl/e7OzOIe3u49b2lCS3ziEhH3S6O/4lGZa4zfWgDylIqJU9Ucm6VC4HLgEOety5RIYB24ojwt5+4k7fA7pC0obyraq3trhr+a2y+Z95WEtHxHk5kM/sgLrBT5XkunSErGtjhrOID0qaX5/tC0xFrjs/MaZ0QNutzVFxiTQ1mK8Fj7wto/KwCtcZfp8AdwIetmVN9uxrRWWi25jHUe7/BsyRtKvvHXbdW0RMBa7KN8/e+g5b0PYzZaOkm/83sEfydG7nM8WN3NFZL2nlmALz/t3k/YJzM2heEf8CrXeWLAM1gh4AAAAASUVORK5CYII=);
        }
      }
    }
    em {
      background-position: center center;
      background-size: 100%;
    }
  }
  &-btn {
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: ptrd(112px);
      height: ptrd(56px);
      background-image: linear-gradient(270deg, #828ca0 0%, #a2a9b8 100%);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: ptrd(8px);
      color: #fff;
      font-size: ptrd(22px);
      em {
        margin-right: ptrd(8px);
      }
    }
  }
}
</style>
